<template>
  <b-container>
    <b-modal
      ref="modal-rescue-password"
      title="Resgatar senha"
      hide-footer
      class="modal-rescue-password"
      header-bg-variant="secondary"
      header-text-variant="light"
    >
      <sp-form @onSubmit="submit" @onReset="reset">
        <b-row no-gutters>
          <b-col class="right">
            <sp-form-cpfcnpj mode="CPF" v-model="form.cpf" required />
            <sp-form-date label="Data de Nascimento" v-model="form.nascimento" required />
            <b-row no-gutters>
              <b-col>
                <sp-form-input
                  label="Senha"
                  type="password"
                  class="pr-2"
                  v-model="form.password"
                  rules="required"
                />
              </b-col>
              <b-col>
                <sp-form-input
                  label="Repita a Senha"
                  type="password"
                  v-model="form.passwordConfirmation"
                  rules="required"
                />
              </b-col>
            </b-row>
            <b-row no-gutters>
              <b-col cols="4" xl="5">
                <div style="margin-top: 8px" class="text-center">
                  <sp-captcha ref="captcha" />
                </div>
              </b-col>
              <b-col cols="8" xl="7">
                <sp-form-input
                  label="Insira o código da imagem ao lado"
                  v-model="form.captcha"
                  rules="required"
                  size
                />
              </b-col>
            </b-row>
            <b-row no-gutters class="mt-3">
              <b-col>
                <sp-button variant="secondary" class="w-90 b" type="reset"> Cancelar </sp-button>
              </b-col>
              <b-col>
                <sp-button class="w-90 b" type="submit" :loading="loading"> Resgatar </sp-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </sp-form>
    </b-modal>
  </b-container>
</template>
<script>
import { firstAcessService } from '@/services';

export default {
  props: {
    city: String,
  },
  data() {
    return {
      form: firstAcessService.getBlankForm(),
      loading: false,
    };
  },
  methods: {
    show() {
      this.form = firstAcessService.getBlankForm();
      this.$refs['modal-rescue-password'].show();
    },
    reset() {
      this.$refs['modal-rescue-password'].hide();
    },
    setLoading(loading) {
      this.loading = loading;
    },
    submit() {
      try {
        firstAcessService.formValidation(this.form, this.$refs.captcha);
        const parsedForm = firstAcessService.parseToRequest(this.form);
        this.$emit('submit', parsedForm, this.setLoading, this.reset);
      } catch (error) {
        this.$alertify.error(error.message);
      }
    },
  },
};
</script>
